import type { CamelCasedPropertiesDeep } from "type-fest";
import { recursiveCamelCaseCipherTypesafe } from "../../postgrestApi/common";
import FetchClients, { ClientOutput } from "../client";
import { throwBackpackResponseError } from "../errors";

export const ACCOUNT_SITES_STATS_KEY = "account-sites-stats";

export type AccountSiteStats = Omit<
  CamelCasedPropertiesDeep<ClientOutput["site"]["SiteStats"]>,
  "status"
>;

const stats = {
  getAccountSitesStats,
} as const;

export default stats;

/**
 * Onboarding progress for every active site on an account, keyed by site id for
 * lookup while building map markers.
 */
export async function getAccountSitesStats(accountId: number) {
  const { data, error } = await FetchClients.site.GET("/stats", {
    params: { query: { account_id: accountId, status: "active" } },
  });
  if (data) {
    return recursiveCamelCaseCipherTypesafe(data).reduce<
      Record<number, AccountSiteStats>
    >((result, { status, ...siteStats }) => {
      result[siteStats.siteId] = {
        ...siteStats,
        percent: Math.round(siteStats.percent),
      };
      return result;
    }, {});
  }
  throwBackpackResponseError(error);
}
